import React from 'react';

import { DevLayout } from '@components/dev/DevLayout';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';
import camelCase from 'lodash-es/camelCase';

const useStyles = makeMuiStyles((theme, common) => ({
  svgContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(8, 1fr)',
    rowGap: '1rem',
    backgroundColor: theme.palette.base[300],
    minHeight: '100vh',
    padding: '1rem',
  },
  itemContainer: {
    ...common.flexColumnCenter,
    height: 75,
  },
}));

export const Svgs: React.FC = () => {
  const svgs = import.meta.glob('../../assets/img/icons/**/*.svg', { eager: true, query: '?url', import: 'default' });

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <DevLayout>
      <div className={classes.svgContainer}>
        {Object.entries(svgs).map(([src, module]) => (
          <div key={src} className={classes.itemContainer}>
            <img src={module} style={{ maxHeight: '100%' }} />
            <div
              className={clsx(classes.middleText, classes.textGray500)}
              onClick={async () => {
                const url = src.replace(/^\.\.\/\.\.\/assets/, '@assets');
                const name = src.split('/')[src.split('/').length - 1];
                const camelCaseName = camelCase(name);
                const importCode = `import ${camelCaseName} from ${JSON.stringify(url)}`;
                await navigator.clipboard.writeText(importCode);
                alert('Import code copied!');
              }}
            >
              {src.split('/')[src.split('/').length - 1]}
            </div>
          </div>
        ))}
      </div>
    </DevLayout>
  );
};
